import { Pane, Heading, Paragraph, Text, PhoneIcon, EnvelopeIcon, MapMarkerIcon, Card } from 'evergreen-ui';
import HeroBanner from '../commons/HeroBanner';
import { CONTACT } from '../constants/contact';

export default function ContattiPage() {
  return (
    <Pane className="public-page-container">
      <HeroBanner 
        title="Contattaci" 
        bgImage="/contatti (2).png" 
      />
      
      <Pane maxWidth={800} marginX="auto" paddingY={60} paddingX={20} textAlign="center">
        <Paragraph size={600} marginBottom={40}>
          Siamo a disposizione per informazioni e collaborazioni.
        </Paragraph>
        
        <Card backgroundColor="white" elevation={2} padding={40} borderRadius={8} display="flex" flexDirection="column" gap={24}>
          <Heading size={700} color="green">{CONTACT.orgName}</Heading>

          <Pane display="flex" alignItems="center" justifyContent="center" gap={12}>
            <MapMarkerIcon color="muted" size={20} />
            <Text size={500}> {CONTACT.addressLabel}</Text>
          </Pane>

          <Pane display="flex" alignItems="center" justifyContent="center" gap={12}>
            <PhoneIcon color="muted" size={20} />
            <Text size={500}> {CONTACT.phone}</Text>
          </Pane>

          <Pane display="flex" alignItems="center" justifyContent="center" gap={12}>
            <EnvelopeIcon color="muted" size={20} />
            <Text size={500} is="a" href={`mailto:${CONTACT.email}`}> {CONTACT.email}</Text>
          </Pane>
        </Card>
      </Pane>
    </Pane>
  );
}